export default "__VITE_ASSET__BloxfTlB__"